/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TransportAutoCarFrontIcon20Solid = forwardRef('TransportAutoCarFrontIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m17.596 8-1.515-3.75A2 2 0 0 0 14.227 3H5.773A2 2 0 0 0 3.92 4.25L2.404 8H1a1 1 0 0 0 0 2h1v6.5A1.5 1.5 0 0 0 3.5 18h1A1.5 1.5 0 0 0 6 16.5V16h8v.5a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5V10h1a1 1 0 1 0 0-2h-1.404ZM4 11a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm9-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z" })));
});
